import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RiGlobalLine } from '@remixicon/react';
import { cn } from '@/utils/helpers';

interface DomainCellProps {
  domain: {
    id: number;
    domain: string;
    title?: string | null;
  };
  showTitle?: boolean;
  dense?: boolean;
  linked?: boolean;
  showID?: boolean;
}

export function DomainCell({
  domain,
  showTitle = true,
  dense = false,
  linked = false,
  showID = false
}: DomainCellProps) {
  const { t } = useTranslation();
  const content = (
    <div className="group flex flex-col">
      <div className="flex items-center gap-1">
        <div className="shrink-0">
          <RiGlobalLine
            className={cn(
              'text-default-400 group-hover:text-primary shrink-0 transition-colors',
              dense ? 'size-3' : 'size-5'
            )}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className={cn('font-medium', dense && 'text-xs')}>{domain.domain}</span>
          {showID && (
            <span className={cn('text-default-400 font-mono', dense ? 'text-xs' : 'text-sm')}>
              {dense ? `did${domain.id}` : `id:${domain.id}`}
            </span>
          )}
        </div>
      </div>
      {showTitle && domain.title && <span className="text-default-500 text-xs">{domain.title}</span>}
    </div>
  );

  if (linked) {
    return (
      <Link
        to={`/domains?domain=${encodeURIComponent(domain.domain)}`}
        className="block transition-opacity hover:opacity-80"
      >
        {content}
      </Link>
    );
  }

  return content;
}
